import { appwriteConfig, databaseId } from '../config/appwrite';

const CONFIG_DOC_ID = 'global';
const TABLE_ID = 'article_extractor_configs';
let loadingInformationPromise: Promise<string> | null = null;

const buildRowUrl = (): string =>
  `${appwriteConfig.endpoint}/tablesdb/${databaseId}/tables/${TABLE_ID}/rows/${CONFIG_DOC_ID}`;

const buildRowsUrl = (): string =>
  `${appwriteConfig.endpoint}/tablesdb/${databaseId}/tables/${TABLE_ID}/rows`;

const readErrorBody = async (response: Response): Promise<string> => {
  try {
    const data = await response.json();
    return typeof data?.message === 'string' ? data.message : '';
  } catch {
    return '';
  }
};

const fetchInformationFromAppwrite = async (): Promise<string> => {
  const response = await fetch(buildRowsUrl(), {
    method: 'GET',
    headers: {
      'X-Appwrite-Project': appwriteConfig.projectId,
      Accept: 'application/json'
    },
    credentials: 'include'
  });

  if (!response.ok) {
    const message = await readErrorBody(response);
    const error = new Error(message || `Serverfehler (${response.status})`) as Error & { code?: number };
    error.code = response.status;
    throw error;
  }

  const data = await response.json();
  const rows = Array.isArray(data?.rows) ? data.rows : [];
  const configRow = rows.find((row: any) => row?.$id === CONFIG_DOC_ID);

  if (!configRow) {
    throw new Error('Der gespeicherte Zusatztext konnte nicht gefunden werden.');
  }

  const information = configRow.information ?? configRow.data?.information;
  return typeof information === 'string' ? information : '';
};

const saveInformationToAppwrite = async (information: string): Promise<void> => {
  const response = await fetch(buildRowUrl(), {
    method: 'PATCH',
    headers: {
      'X-Appwrite-Project': appwriteConfig.projectId,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({
      data: { information }
    })
  });

  if (!response.ok) {
    const message = await readErrorBody(response);
    const error = new Error(message || `Serverfehler (${response.status})`) as Error & { code?: number };
    error.code = response.status;
    throw error;
  }
};

export class ArticleExtractorConfigService {
  static async getInformation(): Promise<string> {
    if (!loadingInformationPromise) loadingInformationPromise = fetchInformationFromAppwrite();
    try { return await loadingInformationPromise; }
    finally { loadingInformationPromise = null; }
  }

  static async saveInformation(information: string): Promise<void> {
    await saveInformationToAppwrite(information);
    const saved = await fetchInformationFromAppwrite();
    if (saved !== information) throw new Error('Speichern konnte nicht bestätigt werden. Bitte versuche es erneut.');
  }
}
